import { Trans } from "react-i18next";

import util from "utils/utils";

export default function DiscussionReactedContent({ ownerGroup, events }) {
  return (
    <Trans
      i18nKey="notifications.groupDiscussionReacted"
      values={{
        name: util.getEventNames(events),
        group: ownerGroup?.name || "Deleted",
      }}
      components={{ b: <b /> }}
    />
  );
}
